import type { FilterItem } from '@schibsted-nmp/search-frontend-clients/quest';
import { Button } from '@warp-ds/react';
import React from 'react';

type SingleSelectCategoryItemsProps = {
    onSelect: (filterItem: FilterItem, parentItem?: FilterItem) => void;
    parentItem: FilterItem;
};

export function SingleSelectCategoryItems(
    props: SingleSelectCategoryItemsProps,
) {
    const { onSelect, parentItem } = props;
    const childItems = parentItem.filter_items ?? [];

    return (
        <fieldset className="field">
            {childItems.map((item) => (
                <Button
                    className="block! mb-4 text-left"
                    link
                    key={item.value}
                    onClick={() => onSelect(item, parentItem)}
                >
                    {item.display_name}
                    {' ' /* Add a space between the name and the hits */}
                    <span className="text-s s-text-subtle">({item.hits})</span>
                </Button>
            ))}
        </fieldset>
    );
}
